/** Clasificación del estado de una fuente para el panel «Fuentes».
 *
 * Extraído de SourcesPage para poder testearlo (deuda de tests de frontend).
 * Espeja los umbrales del watchdog del backend (`app/source_health.py`): una
 * fuente diaria se considera obsoleta a los 2 días (48 h), etc.
 */
export type SourceStatus = "ok" | "warning" | "error" | "pending" | "inactive";

export type SourceLike = {
  is_active: boolean;
  frequency: string;
  last_checked_at: string | null;
  last_successful_at: string | null;
};

// Horas de gracia antes de considerar una fuente desactualizada.
export const OK_HOURS: Record<string, number> = {
  daily: 48, weekly: 192, monthly: 792, quarterly: 2280,
};

export function sourceStatus(s: SourceLike, now: number = Date.now()): SourceStatus {
  if (!s.is_active) return "inactive";
  if (!s.last_checked_at) return "pending";
  if (!s.last_successful_at) return "error";
  const hours = (now - new Date(s.last_successful_at).getTime()) / 3600000;
  const threshold = OK_HOURS[s.frequency] ?? 48;
  if (hours < threshold) return "ok";
  if (hours < threshold * 1.5) return "warning";
  return "error";
}
